import { createFileRoute } from '@tanstack/react-router'
import MidResolutionPage from '@/pages/MidResolutionPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/mid/')({
  component: MidResolutionPage,
})